import {
  Checkbox,
  TextInput,
  Text,
  Textarea,
  NumberInput,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { IconGps } from "@tabler/icons-react";
import type { ControllerRenderProps, FieldValues } from "react-hook-form";
import { useSelector } from "../../../../../../redux/hooks";
import { useMemo } from "react";
import VaccineAttachment from "../sections/VaccineAttachment/VaccineAttachment";
import MedicationAcceptance from "./MedicationAcceptance";

interface Props {
  field: ControllerRenderProps<FieldValues, string>;
  unit: string;
  clearedProps: any;
  vaxid?: string | null;
  forwardDate?: boolean;
}

const InputCell = ({
  unit,
  field,
  clearedProps,
  vaxid,
  forwardDate = true,
}: Props) => {
  const { uppercase } = useSelector(state => state.preferencesSlice);
  const uppercaseStyles = useMemo(() => {
    const transform = {
      textTransform: uppercase ? "uppercase" : "none",
    };
    return {
      input: transform,
      item: {
        ...transform,
        wordBreak: "keep-all",
      },
      ...transform,
    };
  }, [uppercase]);
  const globalMaxDate = useMemo(
    () => (forwardDate ? undefined : new Date()),
    [forwardDate],
  );
  switch (unit) {
    case "text":
      return (
        <TextInput {...clearedProps} {...field} styles={uppercaseStyles} />
      );
    case "large/text":
      return (
        <Textarea
          {...clearedProps}
          {...field}
          styles={{
            ...uppercaseStyles,
          }}
          autosize
          minRows={1}
        />
      );
    case "num":
      return (
        <NumberInput
          {...clearedProps}
          {...field}
          styles={uppercaseStyles}
          hideControls
        />
      );
    case "check":
      return (
        <Checkbox icon={IconGps} size="lg" {...field} checked={field.value} />
      );
    case "date":
      return (
        <DateInput
          {...clearedProps}
          {...field}
          value={field.value ? new Date(field.value) : undefined}
          valueFormat="DD MMM YYYY"
          styles={uppercaseStyles}
          maxDate={globalMaxDate}
          dropdownType="popover"
          popoverProps={{
            position: "top-start",
            withinPortal: true,
            zIndex: 1000,
          }}
        />
      );
    case "day/month":
      const currentYear = new Date().getFullYear();
      const minDate = new Date(currentYear, 0, 1); // Jan 1
      const maxDate = new Date(currentYear, 11, 31); // Dec 31
      return (
        <DateInput
          {...clearedProps}
          {...field}
          value={field.value ? new Date(field.value) : undefined}
          valueFormat="DD MMM"
          minDate={minDate}
          maxDate={maxDate}
          styles={uppercaseStyles}
          dropdownType="popover"
          popoverProps={{
            position: "top-start",
            withinPortal: true,
            zIndex: 1000,
          }}
        />
      );
    case "attachment":
      return (
        <VaccineAttachment
          inputId={field.name}
          vaxid={vaxid || null}
          initialAttachments={field.value}
        />
      );
    case "sig/acceptance":
      return <MedicationAcceptance id={field.name} />;
    case "BLANK":
      return (
        <Text align="center" style={uppercaseStyles as any}>
          {field.value}
        </Text>
      );
    default:
      return <p>default</p>;
  }
};
export default InputCell;
